// @ts-ignore
import View from '@plone/volto/components/manage/Blocks/Teaser/View';
import './teaser.scss';

export default View;
